(function($) {
    jQuery('.celebration-lightbox-close-icon').click(function(){
        var cardID = jQuery('.celebration-lightbox-content').data('contentid');
        jQuery('.celebration-lightbox-canvas').fadeOut(400, function(){
            jQuery('.celebration-lightbox-video iframe').attr('src', '');
        });
        jQuery('.celebration-lightbox-canvas').removeFocusTrap();
        jQuery('.path-card-'+cardID).focus().attr('aria-expanded', false);
        jQuery('html').removeClass('celebration-lightbox-noscroll');
        return false;
    });

    jQuery('.celebration-path').find('.path-card').each(function(){
        jQuery(this).click(function(e){
            var contentID = jQuery(this).attr("data-card-id");
            vkLightboxOpen(contentID);
            jQuery(this).attr('aria-expanded', true);
            return false;
        });
    });

    jQuery('.celebration-lightbox-arrow-left').click(function(){
        vkLightboxChangeSlide(false);
        return false;
    });
    jQuery('.celebration-lightbox-arrow-right').click(function(){
        vkLightboxChangeSlide(true);
        return false;
    });
})( jQuery );

function vkLightboxOpen(contentID){
    vkLightboxSetContent(contentID);
    jQuery('.celebration-lightbox-canvas').css("display", "flex").hide().fadeIn(400);
    jQuery('html').addClass('celebration-lightbox-noscroll');
    if(jQuery('.scrollToTop').is(":visible")){
        jQuery('.scrollToTop').hide();
    }
    jQuery('.celebration-lightbox-canvas').focusTrap();
}

function vkLightboxSetContent(contentID){
    var content = celebration_lightbox_content[contentID];
    jQuery('.celebration-lightbox-content').data('contentid', contentID);
    jQuery('.celebration-lightbox-title').text(content['title']);
    jQuery('.celebration-lightbox-image').empty();
    jQuery('.celebration-lightbox-video iframe').remove();
    if (content['image']){
        jQuery('.celebration-lightbox-image').empty().append('<div class="lightbox-image"><img src="'+content['image']+'"></img></div>');
    } else if (content['video']){
        var iframe =  jQuery('<iframe src="' + content['video'] + '"></iframe>');
        jQuery('.celebration-lightbox-video .video-embed-container').append(iframe);
    } else if (content['videoyoutube']){
        var iframe = jQuery(content['videoyoutube']);
        jQuery('.celebration-lightbox-video .video-embed-container').append(iframe);
    }
    jQuery('.celebration-lightbox-text').empty().append('<div class="scrollable-content" tabindex="0">'+content['text']+'</div>');

    function decodeHtmlEntities(str){
        const textarea = document.createElement('textarea');
        textarea.innerHTML = str;
        return textarea.value;
    }

    jQuery('.celebration-lightbox-accordion').empty();
    if (content.accordions){
        jQuery('.celebration-lightbox-accordion').append('<ul class="accordion" data-accordion data-multi-expand="true" data-allow-all-closed="true"></ul>');
        for(var key in content.accordions){
            var item = content.accordions[key];
            var decodedTitle = decodeHtmlEntities(item.title || '');
            var decodedText = decodeHtmlEntities(item.text || '');

            var $accordionItem = jQuery('<li class="accordion-item" data-accordion-item>' + '<a href="#" class="accordion-title"></a>' + '<div class="accordion-content" data-tab-content></div>' + '</li>');
            
            $accordionItem.find('.accordion-title').html(decodeHtmlEntities(item.title || '')); 
            $accordionItem.find('.accordion-content').html(decodeHtmlEntities(item.text || '')); 
            jQuery('.celebration-lightbox-accordion .accordion').append($accordionItem);
        }
        var accordionElement = jQuery('.celebration-lightbox-accordion .accordion');
        new Foundation.Accordion(accordionElement);
    }
    jQuery('.celebration-lightbox-files').empty();
    for(var key in content['files']){
        jQuery('.celebration-lightbox-files').append('<p class="celebration-lightbox-file-link"><a href="'+content['files'][key]['url']+'" aria-label="Lataa tiedosto" target="_blank">'+content['files'][key]['title']+'</a></p>');
    }
}

function vkLightboxChangeSlide(forward){
    var currentContentID = parseInt(jQuery('.celebration-lightbox-content').data('contentid'));
    var count = Object.keys(celebration_lightbox_content).length;
    var changeTo = 0;
    if(forward){
        if(currentContentID == count){
            changeTo = 1;
        }else{
            changeTo = currentContentID + 1;
        }
    }else{
        if(currentContentID == 1){
            changeTo = count;
        }else{
            changeTo = currentContentID - 1;
        }
    }
    vkLightboxSetContent(changeTo);
}